// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.badge.badge-money {\r\n  color: green;\n}\n.paylink-invoice-input-row {\r\n  margin-bottom: 25px;\n}\n.paylink-invoice .btn-group {\r\n  padding: 0;\n}\n.text-align-left {\r\n  text-align: left;\n}\r\n", ""]);
// Exports
module.exports = exports;
